module.exports = __webpack_public_path__ + "img/ico_apply.af91d1a6.svg";